import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState, useCallback } from "react";
import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";
import PageHeader from "../shared-components/PageHeader";
import Pagination from "../shared-components/Pagination";
import Table from "./Table";
import { useGetSelfServeReports } from "../api/SelfServeApi";

const SelfService = () => {
  const {
    isLoading: loadingSelfService,
    data: selfServiceData,
    refetch: getSelfServiceList,
    error: errorGettingSelfService,
  } = useGetSelfServeReports();

  const pageSize = 25;
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  function fetchSelfServiceListBaseProps() {
    getSelfServiceList();
  }

  const fetchSelfServiceList = useCallback(() => {
    fetchSelfServiceListBaseProps();
    // eslint-disable-next-line
  }, [page]);

  useEffect(() => {
    fetchSelfServiceList();
  }, [fetchSelfServiceList]);

  useEffect(() => {
    setTotal(selfServiceData?.total_rows ?? 1);
  }, [selfServiceData]);

  useEffect(() => {
    if (searchParams.get("page")) {
      setPage(Number(searchParams.get("page")));
    }
  }, [searchParams]);

  if (errorGettingSelfService) {
    return <ErrorMessageContainer message="Couldn't load self-service list" />;
  }

  const tableHeader = [
    { name: "Name" },
    { name: "Requested By" },
    { name: "Status" },
    { name: "Date Started" },
    { name: "Date Completed" },
    { name: "Payment Token" },
    { name: "Report UUID" },
  ];

  return (
    <>
      <PageHeader title={"Self Serve Reports"} />
      <div className="w-5/12"></div>
      <div>
        <Table
          isLoading={loadingSelfService}
          header={tableHeader}
          data={selfServiceData?.items ?? []}
          onEventComplete={fetchSelfServiceList}
        />
      </div>
      <Pagination
        pageSize={pageSize}
        currentPage={page}
        totalCount={total}
        search={""}
      />
    </>
  );
};

export default SelfService;
